'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tabsStyle = {
  position: 'absolute',
  bottom: '30px',
  right: '270px',
  boxShadow: '2px 2px 5px #888888',
  zIndex: 9999
};

var tabStyle = {
  width: '50px',
  height: '50px',
  display: 'inline-block',
  backgroundColor: '#f8f8ff',
  color: '#888888',
  marginRight: '1px',
  fontSize: '35px',
  textAlign: 'center',
  cursor: 'pointer',
  lineHeight: 'normal'
};

var Tab = function Tab(_ref) {
  var index = _ref.index;
  var _onClick = _ref.onClick;
  var isActive = _ref.isActive;
  return _react2.default.createElement(
    'div',
    {
      onClick: function onClick() {
        return _onClick(index);
      },
      className: 'redux-test-recorder-tab',
      style: isActive ? _extends({}, tabStyle, { backgroundColor: '#9ACBDB' }) : tabStyle
    },
    index + 1
  );
};

var Tabs = function Tabs(_ref2) {
  var numTests = _ref2.numTests;
  var onTabClick = _ref2.onTabClick;
  var _ref2$testIndex = _ref2.testIndex;
  var testIndex = _ref2$testIndex === undefined ? numTests - 1 : _ref2$testIndex;

  var range = Array.from({ length: numTests }).map(function (x, i) {
    return i;
  });
  return _react2.default.createElement(
    'div',
    { style: tabsStyle, className: 'redux-test-recorder-tabs' },
    range.map(function (n) {
      return _react2.default.createElement(Tab, { key: n, index: n, onClick: onTabClick, isActive: testIndex === n });
    })
  );
};

exports.default = Tabs;


/*****************
 ** WEBPACK FOOTER
 ** ./dist/tabs.js
 ** module id = 185
 ** module chunks = 0
 **/